import ReactDOM from 'react-dom';
import { useEffect } from '@wordpress/element';

// Ensure shared modal host is mounted and window.JkitOpenPricingModal is available
import '../shared/modal-host';

const SELECTOR = 'a.upgrade, .button-upgrade-pro, .button-upgrade, .upgrade-pro-btn, .jkit-upgrade-to-pro-menu a, #wp-admin-bar-jeg-kit-pro, .jkit-upgrade-banner .jkit-banner-cta-button-wrapper .jkit-banner-cta-button, .f-button-upgrade, #jkit-onboard-wizard .upgrade-pro-button, #jkit-onboard-wizard .f-button-upgrade, a.upgrade-to-pro.jeg-kit-pro, a.jkit-meta-upgrade-to-pro, a.jkit-update-now-pricing';

const AdminHost = () => {
    useEffect(() => {
        const onClick = (e) => {
            const el = e.target.closest && e.target.closest(SELECTOR);
            if (!el) return;
            const modalContext = el.matches && el.matches('a.jkit-update-now-pricing')
                ? {
                    source: 'plugin-update',
                    continueUrl: el.getAttribute('data-continue-url') || '',
                    continueLabel: el.getAttribute('data-continue-label') || '',
                }
                : null;

            try {
                e.preventDefault();
                e.stopPropagation();
                if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
            } catch (err) {
                // ignore
            }

			if (typeof window.JkitOpenPricingModal === 'function') {
                window.JkitOpenPricingModal(modalContext);
				return;
			}

            const href = (el.getAttribute && el.getAttribute('href')) || (window.location.origin + '/wp-admin/admin.php?page=jkit');
            window.open(href, '_blank');
        };

        document.addEventListener('click', onClick, true);
        document.addEventListener('auxclick', onClick, true);
        return () => {
            document.removeEventListener('click', onClick, true);
            document.removeEventListener('auxclick', onClick, true);
        };
    }, []);

    return null;
};

const mount = () => {
    if (typeof document === 'undefined') return;
    let root = document.getElementById('jkit-admin-host-root');
    if (!root) {
        root = document.createElement('div');
        root.id = 'jkit-admin-host-root';
        document.body.appendChild(root);
    }
    try {
        if (ReactDOM && typeof ReactDOM.createRoot === 'function') {
            ReactDOM.createRoot(root).render(<AdminHost />);
        } else {
            ReactDOM.render(<AdminHost />, root);
        }
    } catch (e) {
        ReactDOM.render(<AdminHost />, root);
    }
};

if (document.readyState === 'complete' || document.readyState === 'interactive') {
    mount();
} else {
    window.addEventListener('load', mount);
}

export default {};
